export function numberToWord(num) {
  const unidades = [
    'cero', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve',
    'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve',
  ];
  const decenas = [
    '', '', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa',
  ];
  const centenas = [
    '', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos',
  ];

  let result = '';
  if (num === 0) {
    [result] = unidades;
  } else if (num < 20) {
    result = unidades[num];
  } else if (num < 100) {
    result = decenas[Math.floor(num / 10)];
    if (num % 10 !== 0) {
      result += ` y ${unidades[num % 10]}`;
    }
  } else if (num < 1000) {
    result = centenas[Math.floor(num / 100)];
    if (num % 100 !== 0) {
      result += ` ${numberToWord(num % 100)}`;
    }
  }
  return result;
}
